const terminationMutualAgreement = `
    <table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
        <tr>
            <td>
                <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
            </td>
        </tr>
        <tr>
            <td align="center" height='100px'>
                <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>DISTRATO DE PRESTAÇÃO DE SERVIÇO</strong></p>
            </td>
        </tr>
        <tr>
            <td>
            <div class="main">

                <p>
                    Pelo presente instrumento, e na melhor forma de direito, de um lado, <strong> NAÇÃO DIGITAL SOLUTIONS S.A.</strong>, e tem a sua sede na Cidade de Maringá, Estado do Paraná, na Av. João Paulino Vieira Filho, nº 672, Edifício New Center Empresarial, sala 101, Zona 01, CEP 87020-015, inscrita no CNPJ sob o n 15.340.754/0001-82, doravante designado CONTRATANTE. E, de outro <strong>{{companyname}}</strong>, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº{{companynumber}}, CEP. {{companycep}}, {{companycity}}/{{companystate}}, doravante designada <strong>CONTRATADA</strong>.
                </p>

                <!-- CORPO DO DOCUMENTO -->

                <p>
                    Decidem de comum e mútuo acordo, rescindir nesta data o <strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS EM INFORMÁTICA</strong> firmado em <strong>{{contractstart}}</strong>
                </p>

                <p>
                    As partes declaram que o pagamento referente à contraprestação pecuniária aos serviços de consultoria prestados, será realizado em até 15 (quinze) dias corridos, contados da data de assinatura por ambas as PARTES desde instrumento, observação os critérios essenciais de: emissão de nota fiscal e entrega dos equipamentos em comodato no momento de assinatura de contrato.
                </p>

                <p>
                    A <strong>CONTRATADA</strong> declara que houve a devolução de todos os equipamentos da <strong>CONTRATANTE</strong>, que estavam em sua posse, na seda da <strong>CONTRATANTE</strong>, qual o endereço: Av. João Paulino Vieira Filho, nº 672, Edifício New Center Empresarial, sala 101, Zona 01, CEP 87.020-015, na cidade de Maringá, Estado do Paraná. Caso o equipamento não tenha sido entregue em sua totalidade, ou ainda, contenham problemas de mau uso ou avarias, mediante verificação da assistência técnica, ocorrerá o desconto dos valores apurados, pelos danos aos equipamentos.
                </p>

                <p>
                As Partes desde já acordam, que o presente Contrato será assinado eletronicamente, via plataforma DocuSign, cuja validade para todos os fins é reconhecimento pelos signatários, nos termos do artigo 10 º, § 2 º, da MP 2.200-2/2001.
                </p>

                <p>
                E por estarem assim justas e contratadas, assinam as partes, bem como duas testemunhas o presente instrumento.
                </p>
                <br>
                </td>
                </tr>
                <tr>
                <td align="center" height='60px'>
                <p style="text-align: center; margin-top: 50px;">
                    <strong>Maringá</strong>, {{contractend}}
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>NAÇÃO DIGITAL SOLUTIONS S.A
                        CONTRATANTE</strong>
                    </span>
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        {{companyname}}<br>
                    </span>
                </p>

                <!-- TESTEMUNHASSSS -->
                <p style="margin-top: 50px;">
                    <strong>TESTEMUNHAS</strong>
                </p>
                <div class="testemunhas" style="margin: 0; text-align: left;">
                    <table style="width: 100%;">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td style="width: 50%;">
                                    <span>
                                        1. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                                <td style="width: 50%;">
                                    <span>
                                        2. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </td>
        </tr>
    </table>
`;

export default terminationMutualAgreement;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/terminationMutualAgreement.ts